import type { PropType } from 'vue';
import type { TLoadingProps } from './TLoading.types';
import { merge } from 'es-toolkit/compat';
import { computed, defineComponent } from 'vue';
import { TSpinner } from '../TSpinner';
import { useStyles } from './TLoading.styles';

const defaultProps = {
  size: 'auto',
};

export const TLoading = defineComponent({
  name: 'TLoading',
  props: {
    active: Boolean as PropType<TLoadingProps['active']>,
    fullPage: Boolean as PropType<TLoadingProps['fullPage']>,
    size: String as PropType<TLoadingProps['size']>,
  },
  setup(_props, { attrs }) {
    const props = computed(() => merge({}, defaultProps, _props, attrs));

    const baseClass = useStyles();
    const classes = computed(() => [
      baseClass.value,
      {
        [`${baseClass.value}--active`]: props.value.active,
        [`${baseClass.value}--full-page`]: props.value.fullPage,
      },
    ]);

    return () => (
      <div class={classes.value}>
        <TSpinner size={props.value.size} />
      </div>
    );
  },
});
